import { token } from '@atlaskit/tokens';
import { type DatabaseFieldType } from '@databases/types/database';
import React, { type FunctionComponent } from 'react';
import styled from 'styled-components';

import { type ViewComponentProps } from './types';

const Container = styled.span<{
  showDisabledValue?: boolean;
}>`
  white-space: pre-line;
  color: ${({ showDisabledValue }) =>
    showDisabledValue ? token('color.text.disabled', '#8993A4') : 'inherit'};
`;

const TextValueView: FunctionComponent<ViewComponentProps<DatabaseFieldType.TEXT>> = ({
  value,
  showDisabledValue,
}) => {
  return <Container showDisabledValue={showDisabledValue}>{value}</Container>;
};

export default TextValueView;
